import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type Theme = 'light' | 'dark';

interface ThemeStore {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

// Version du store pour forcer la migration vers le mode sombre
const THEME_STORE_VERSION = 2;

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set, get) => ({
      theme: 'dark', // Mode sombre par défaut pour tous les nouveaux utilisateurs
      setTheme: (theme: Theme) => {
        set({ theme });
        document.documentElement.setAttribute('data-theme', theme);
      },
      toggleTheme: () => {
        const newTheme = get().theme === 'light' ? 'dark' : 'light';
        get().setTheme(newTheme);
      },
    }),
    {
      name: 'hockey-dynasty-theme',
      version: THEME_STORE_VERSION,
      migrate: (persistedState: any, version: any) => {
        // Force le mode sombre pour tous les utilisateurs lors de cette migration
        if (version !== THEME_STORE_VERSION) {
          return { theme: 'dark' };
        }
        return persistedState;
      },
      onRehydrateStorage: () => (state) => {
        if (state) {
          document.documentElement.setAttribute('data-theme', state.theme);
        } else {
          // Pour les nouveaux utilisateurs ou si pas de préférence sauvegardée, 
          // on force le mode sombre
          document.documentElement.setAttribute('data-theme', 'dark');
        }
      },
    }
  )
);
